import { ReviewsApiConfig } from '../typings/reviews';

export const DATA_VERSION_ENDPOINT =
  '/api/VWUP/FiveStarRating/v2.0/DataVersion';
export const REVIEWS_ENDPOINT = '/api/VWUP/FiveStarRating/v2.0/reviews';
export const REVIEWS_DEALER_ENDPOINT = '/api/VWUP/FiveStarRating/v2.0/Dealers/USAV[DEALER_ID]';
export const REVIEWS_DEALER_COMMENT_ENDPOINT = "/api/VWUP/FiveStarRating/v2.0/Dealers/[DEALER_ID]/comments";


declare var __API_KEY__: string;

export type reviewsEndpointType = 'dataVersionPath' | 'reviewsProductPath' | 'reviewsDealerPath' | "commentsDealerPath";

export const COUNTRY = "USA"

export function createFetchReviewsUrl(
  apiConfig: ReviewsApiConfig | undefined,
  endpointType: reviewsEndpointType,
  queryParams: URLSearchParams | undefined,
  defaultEndpoint: string,
  dealerId?: string
): string {
  let requestUrl = apiConfig?.urlOrigin || '';
  let pathsConfig = apiConfig?.customConfig as any;
  if (pathsConfig[endpointType]) {
    requestUrl = requestUrl + pathsConfig[endpointType];
  } else {
    requestUrl = requestUrl + defaultEndpoint;
  }
  if (dealerId) {
    requestUrl = requestUrl.replace("[DEALER_ID]", dealerId);
  }
  if (queryParams) {
    requestUrl = requestUrl + '?' + queryParams.toString();
  }
  return requestUrl;
}

/**
 * Creates request headers
 * @param apiKeyContent
 * @returns
 */
export function createReviewServerHeaders(apiKeyContent?: string): any {
  if (!apiKeyContent && !__API_KEY__)
    throw new Error('No configured apiKey was found');
  return {
    'accept': 'application/json',
    'X-API-KEY': apiKeyContent || __API_KEY__,
  };
}


/**
 * Create five stars object params
 * @param model
 * @param rating
 * @param page
 * @param type
 * @param size
 * @returns object
 */
export const createReviewsRequestParams = (
  dataVersion: string,
  model?: string,
  rating?: string,
  page?: number,
  type?: string,
  size?: number,
  country?: string
): URLSearchParams => {
  let params = new URLSearchParams();
  params.set('dv', dataVersion);
  model && params.set('model', model);
  type && params.set('filter_category_key', type);
  if (rating) params.set('filter_stars', rating);
  if (page) params.set('offset', `${page}`);
  if (size) params.set('limit', `${size}`);
  if(country) params.set("country", country)
  return params;
};
